import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
// import Store from 'store/store';
// import FakeChat from 'components/bolt/fakeChat/fakeChat';
import { navigateInternally } from 'utils/bolt/index';

import 'store/serviceArea';

import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount?.();
		if (this.state.appState?.appData?.options?.fakeChat) {
			const component = await import(/* webpackChunkName: "fakeChat" */ 'components/bolt/fakeChat/fakeChat');
			this.FakeChat = component.default;
		}
		// Fix google translate causing node duplication
		const ib = Element.prototype.insertBefore;
		Element.prototype.insertBefore = function(child, ref) {
			if (ref && ref.localName === 'font') {
				child.innerText = ref.innerText;
				return;
			}
			return ib.apply(this, arguments);
		};
	}

	render(props, state) {
		const base = super.render(props, state);
		const { FakeChat } = this;
		if (FakeChat) {
			const openSound = `${state.appState?.appData?.urls?.roots?.media}/audio/mushroom.mp3`;
			base.children.push(
				<FakeChat class={s.fakeChat} onPageLinkClick={navigateInternally} openSound={openSound} />
			);
		}
		return base;
	}
}